import { render } from "./ProfileEditDialog.vue?vue&type=template&id=8573213c&ts=true"
import script from "./ProfileEditDialog.vue?vue&type=script&lang=ts"
export * from "./ProfileEditDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QSpinner,QCard,QCardSection,QBtn,QInput,QSelect,QCardActions});
